export const MAIN = '/';
export const LEVEL = '/level/:level/:game';
